/**
 * Phase 86 — Frontend mirror of `backend/src/constants/platforms.js` (D-85-06).
 *
 * Values MUST stay byte-equal to the backend constant so payloads round-trip
 * without translation. Updated together when a new platform is added.
 *
 * Anti-pattern reminder (CF-4): do NOT add aliases like `IG: 'IG'` to PLATFORMS
 * for "defensive long-vs-short acceptance". Only canonical-form input is
 * accepted. Callers that previously fed short forms must be migrated to
 * canonical at the source.
 *
 * @typedef {(typeof PLATFORMS)[keyof typeof PLATFORMS]} Platform
 */

export const PLATFORMS = Object.freeze({
  INSTAGRAM: 'instagram',
  TIKTOK:    'tiktok',
  YOUTUBE:   'youtube',
  FACEBOOK:  'facebook',
});

export const PLATFORM_ENUM = Object.values(PLATFORMS);

export const CONTACT_ONLY_PLATFORMS = Object.freeze(['threads', 'x']);

export const DONOR_PLATFORM_ENUM = Object.freeze([...PLATFORM_ENUM, ...CONTACT_ONLY_PLATFORMS]);

/**
 * Short labels for compact chips/badges. Replaces the CF-4 `PLATFORM_SHORT`
 * defensive map in the retired zakupy card and the long ternary in CreateBloggerModal /
 * LeadEditModal. Keyed by canonical platform string only — no short-form
 * self-aliases.
 */
export const PLATFORM_LABEL_SHORT = Object.freeze({
  [PLATFORMS.INSTAGRAM]: 'IG',
  [PLATFORMS.TIKTOK]:    'TT',
  [PLATFORMS.YOUTUBE]:   'YT',
  [PLATFORMS.FACEBOOK]:  'FB',
  threads: 'Threads',
  x: 'X',
});
